import SearchMyCourse from './SearchMyCourse';

export default SearchMyCourse;
